export const paramName = 'section'
